module.exports = __webpack_public_path__ + "static/media/icon-teams-roles-checked.04b4f388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-teams-roles-checked.svg
// module id = 1906
// module chunks = 0